import {
} from '../actions';
import {
    CLICK_SHOW_MANUALS,
    SHOW_MANUALS,
    CLICK_CLOSE_MANUALS,
    FAIL_SHOW_MANUALS,
    CLICK_SHOW_POLICY,
    SHOW_POLICY,
    CLICK_CLOSE_POLICY,
    FAIL_SHOW_POLICY,
    CLICK_SHOW_TERMS,
    SHOW_TERMS,
    CLICK_CLOSE_TERMS,
    FAIL_SHOW_TERMS
} from "../actions";

const initialState = {
    manualOpen : false,
    manualUrl : null,
    termsOpen : false,
    termsUrl : null,
    policyOpen : false,
    policyUrl : null,
    isProcessError : false
};
export default function menuSettings(state = initialState, action) {
    let ret = Object.assign({}, state, {});
    switch (action.type) {
        case SHOW_MANUALS:
            ret.manualOpen = true;
            ret.manualUrl = action.payload.pdf;
            return ret;
        case SHOW_POLICY:
            ret.policyOpen = true;
            ret.policyUrl = action.payload.pdf;
            return ret;
        case SHOW_TERMS:
            ret.termsOpen = true;
            ret.termsUrl = action.payload.pdf;
            return ret;
        case CLICK_SHOW_MANUALS:
        case CLICK_CLOSE_MANUALS:
            ret.manualOpen = false;
            ret.manualUrl = null;
            return ret;
        case CLICK_SHOW_POLICY:
        case CLICK_CLOSE_POLICY:
            ret.policyOpen = false;
            ret.policyUrl = null;
            return ret;
        case CLICK_SHOW_TERMS:
        case CLICK_CLOSE_TERMS:
            ret.termsOpen = false;
            ret.termsUrl = null;
            return ret;
        case FAIL_SHOW_MANUALS:
        case FAIL_SHOW_POLICY:
        case FAIL_SHOW_TERMS:
            ret.isProcessError = true;
            return ret;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/documents.js